/* global G */
import { isObj } from 'lib/util'

/**
 * Displays a toast with a translatable `message`.
 *
 * @param {Gaia.AppModule.Spec} obj current module
 * @param {Object} options
 */
const showToast = (obj, options) => {
  const intl = obj[G.ADAPTER][G.INTL]
  const eventBus = obj[G.ADAPTER][G.EVENTS]
  const { duration, message, ...restOptions } = options

  eventBus.dispatch(eventBus.type(G.DATA, G.UPDATE), {
    duration: duration ?? 5000,
    message: !isObj(message) ? message : intl._t(message.key, { ...message, _key: message.key }),
    ...restOptions,
  })
}

/**
 * @typedef {Object} ToastOptions
 * @property {Object} success
 * @property {Object} failure
 */

/**
 * Displays a toast with state `options.failure` if calling passed `hook` throws an error.
 * Otherwise, displays a toast with state `options.success`.
 *
 * @param {function(*): function(...[*]): Promise<*>} hook
 * @param {ToastOptions} options
 * @returns {function(*): function(...[*]): Promise<*>}
 */
const withToast = (hook, options) => obj => async (...args) => {
  let result = args

  try {
    result = await hook(obj)(...args)
    showToast(obj, options.success)
  } catch (e) {
    showToast(obj, options.failure)
    throw e
  }

  return result
}

export default withToast
